export class RoscaOrder {
    constructor(id, date, time, firstName, lastName, phoneNumber, amount, paid, cashier, store_id, customerId = null, pickedUp = false) {
        this.id = id;
        this.date = date;
        this.time = time;
        this.firstName = firstName;
        this.lastName = lastName;
        this.phoneNumber = phoneNumber;
        this.paid = paid;
        this.amount = amount;
        this.cashier = cashier;
        this.store_id = store_id;
        this.customerId = customerId;
        this.pickedUp = pickedUp;
    }

    toJson() {
        return {
            date: this.date,
            time: this.time,
            firstName: this.firstName,
            lastName: this.lastName,
            phoneNumber: this.phoneNumber,
            amount: this.amount,
            paid: this.paid,
            cashier: this.cashier,
            store_id: this.store_id,
            customerId: this.customerId || null,
            pickedUp: this.pickedUp || false,
        };
    }

    static fromFirebase(doc) {
        const data = doc.data();
        return new RoscaOrder(
            doc.id,
            data.date,
            data.time,
            data.firstName,
            data.lastName,
            data.phoneNumber,
            data.amount,
            data.paid,
            data.cashier || 'EN LÍNEA',
            data.store_id,
            data.customerId || null,
            data.pickedUp || false
        );
    }
}
